import { registerQuery } from 'data-fetching-client';
import { getFrameworkDataSchemasClient } from 'framework-data-schema-resolvers';
export const GET_OBJECT_TYPE_DEFINITION = registerQuery({
  fieldName: 'objectTypeDefinition',
  args: ['objectTypeId'],
  fetcher: async ({
    objectTypeId
  }) => {
    const client = await getFrameworkDataSchemasClient();
    const objects = await client.frameworkTypes.getObjects();
    return objects.find(object => object.objectTypeId === objectTypeId);
  }
});